type ComingSoonPageProps = {
  title: string;
  description: string;
};

export const ComingSoonPage = ({ title, description }: ComingSoonPageProps) => {
  return (
    <div className="space-y-6 p-2">
      <header>
        <h1 className="text-2xl md:text-3xl font-bold text-gray-900 dark:text-white tracking-tight">
          {title}
        </h1>
        <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
          {description}
        </p>
      </header>
      <div className="rounded-xl border border-gray-200 dark:border-zinc-700 bg-white dark:bg-zinc-900 p-8 md:p-12 text-center">
        <p className="text-lg font-medium text-gray-700 dark:text-gray-300">
          Próximamente
        </p>
        <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
          Esta sección estará disponible en una próxima actualización.
        </p>
      </div>
    </div>
  );
};
